/* global _ */
import {name, mixins, props, data, validationsRules, parseValidations, parseValidationSetup, EventBus} from './config'

const validationGroupRules = {
  giftcardGroup: [
    'fields.giftcard_number', 'fields.giftcard_cvv'
  ],
  playcardGroup: [
    'fields.playcard_number', 'fields.playcard_cvv'
  ],
  couponGroup: [
    'fields.coupon'
  ]
}

export default {
  name,
  mixins,
  props,

  data() {
    return {
      ...data,
      showInfoModal: false,
      isGiftcard: false,
      isNumberInfo: false,
      showResendModal: false,
      recoverSuccess: false,
      isProgressing: false,
      validations: {},
    }
  },

  validations() {
    return {
      fields: parseValidations(validationsRules),
      ...validationGroupRules
    }
  },

  watch: {
    resendModalSuccess(newVal) {
      this.recoverSuccess = newVal
    }
  },

  created() {
    this.validations = parseValidationSetup(validationsRules, this)
    this.setValidationError(null)
  },

  computed: {
    infoTitle() {
      let text = ''
      if (this.isGiftcard) {
        text = this.isNumberInfo ?  this.giftcardNumberInfoTitle : this.giftcardCodeInfoTitle
      } else {
        text = this.isNumberInfo ?  this.playcardNumberInfoTitle : this.playcardCodeInfoTitle
      }
      return text
    },
    infoHeaderText() {
      let text = ''
      if (this.isGiftcard) {
        text = this.isNumberInfo ?  this.giftcardNumberInfoHeader : this.giftcardCodeInfoHeader
      } else {
        text = this.isNumberInfo ?  this.playcardNumberInfoHeader : this.playcardCodeInfoHeader
      }
      return text
    },
    infoFooterText() {
      let text = ''
      if (this.isGiftcard) {
        text = this.isNumberInfo ?  this.giftcardNumberInfoFooter : this.giftcardCodeInfoFooter
      } else {
        text = this.isNumberInfo ?  this.playcardNumberInfoFooter : this.playcardCodeInfoFooter
      }
      return text
    },
    infoImgSrc() {
      let text = ''
      if (this.isGiftcard) {
        text = this.isNumberInfo ?  this.giftcardNumberInfoImgSrc : this.giftcardCodeInfoImgSrc
      } else {
        text = this.isNumberInfo ?  this.playcardNumberInfoImgSrc : this.playcardCodeInfoImgSrc
      }
      return text
    },
    displayResendModal() {
      return (this.hasGiftcardForgotCodeLink || this.hasHelpPlaycardNumberLink) && this.showResendModal
    },

    showGiftcard() {
      return this.showGiftcardRedmptions || !this.hasOnlyGiftcards
    },
    disabledGiftcardApllyButton() {
      return this.$v.giftcardGroup.$invalid
    },
    disabledPlaycardApllyButton() {
      return this.$v.playcardGroup.$invalid
    },
    disabledCouponApllyButton() {
      return this.$v.couponGroup.$invalid
    },
    isLoadingGiftcard() {
      return this.giftcard.isAdding
    },
    isLoadingPlaycard() {
      return this.isProgressing  && !this.isGiftcard
    },
    isLoadingCoupon() {
      return this.isProgressing
    },
    showErrorMessage() {
      return this.giftcard.error && this.giftcard.errorType !== 'number' && giftcard.errorType !== 'cvv'
    },
    giftcardErrorMessage() {
      return this.giftcard.error || ''
    }
  },

  methods: {
    giftcardNumberInfo() {
      this.showInfoModal = true
      this.isGiftcard = true
      this.isNumberInfo = true
    },
    giftcardCodeInfo() {
      this.showInfoModal = true
      this.isGiftcard = true
      this.isNumberInfo = false
    },
    playcardNumberInfo() {
      this.showInfoModal = true
      this.isGiftcard = false
      this.isNumberInfo = true
    },
    playcardCodeInfo() {
      this.showInfoModal = true
      this.isGiftcard = false
      this.isNumberInfo = false
    },
    closeInfoModal () {
      this.showInfoModal = false
      this.isGiftcard = false
      this.isNumberInfo = false
    },

    giftcardForgotCode() {
      this.showResendModal = true
      this.isGiftcard = true
    },
    playcardForgotCode() {
      this.showResendModal = true
      this.isGiftcard = false
    },
    closeResendModal() {
      this.showResendModal = false
      this.isGiftcard = false
      this.recoverSuccess = false
    },
    recoverByEmail(data) {
      this.$emit('recoverByEmail', data)
      EventBus.$emit('cart.resend-code.by-email', data)
    },
    recoverByNumber(data) {
      this.$emit('recoverByNumber', data)
      EventBus.$emit('cart.resend-code.by-number', data)
    },
    async applyGiftcard(){
      this.$v.giftcardGroup.$touch()
      this.formSubmitting = true
      if (this.$v.giftcardGroup.$anyError) {
        this.giftcard.number = this.giftcard_number
        this.giftcard.cvv = this.giftcard_cvv
        EventBus.$emit('cart.redemption.before.apply-giftcard', this.giftcard)
        try {
          await this.addGiftcard()
          this.formSubmitting = false
          EventBus.$emit('cart.redemption.apply-giftcard', this.giftcard)
        } catch(e) {
          EventBus.$emit('cart.redemption.apply-giftcard.error', e)
        }
      }
    },
    applyPlaycard(){
      this.$v.playcardGroup.$touch()
      this.formSubmitting = true
      if (this.$v.playcardGroup.$anyError) {
        const request = {
          number: this.fields.playcard_number,
          cvv: this.fields.playcard_cvv
        }
        EventBus.$emit('cart.redemption.before.apply-playcard', request)
        this.$emit('applyPlaycard', request)
        EventBus.$emit('cart.redemption.apply-playcard')
      }
    },
    applyCoupon() {
      this.$v.couponGroup.$touch()
      this.formSubmitting = true
      if (this.$v.couponGroup.$anyError) {
        EventBus.$emit('cart.redemption.before.apply-coupon', this.fields.coupon)
        this.$emit('applyCoupon', this.fields.coupon)
        EventBus.$emit('cart.redemption.apply-coupon')
      }
    }

  },
}
